import React from 'react';

interface TableSkeletonProps {
  headers:(string | React.ReactNode)[];
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({ headers }) => {
  return (
    <>
      {Array.from({ length: 3 }).map((_, rowIndex) => (
        <tr key={rowIndex}>
          {headers.map((_, cellIndex) => (
            <td key={cellIndex} className="whitespace-nowrap px-6 py-4">
              <div className="h-8  bg-primary-subtle rounded-lg animate-pulse"></div>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export default TableSkeleton;
